<div class="pdf-viewer-modal">

    <div class="pdf-viewer-header">
        <div class="pdf-viewer-title-row">
            <div class="pdf-viewer-logo">
                <img src="assets/img/cafler-logo.svg" alt="Cafler" class="logo-img" />
            </div>
            <span class="pdf-viewer-name">{{ pdfName }}</span>
        </div>
        <div class="pdf-viewer-actions">
            <button type="button" class="pdf-download-btn" (click)="download()" [title]="(downloadLabelKey || 'delivery-note.download_document') | translate">
                    <tui-icon icon="tuiIconDownload"></tui-icon>
                    <span class="pdf-download-text">{{ (downloadLabelKey || 'delivery-note.download_document') | translate }}</span>
                </button>
            <button type="button" class="pdf-close-btn" (click)="close()">
                <tui-icon icon="tuiIconCloseLarge"></tui-icon>
            </button>
        </div>
    </div>
    <ng-container *ngIf="htmlTemplate">
        <div class="pdf-html-body">
            <ng-container *ngTemplateOutlet="htmlTemplate"></ng-container>
        </div>
    </ng-container>

    <ng-container *ngIf="!htmlTemplate">
    <div class="pdf-viewer-body">

        <div class="pdf-loader" *ngIf="isLoading && !loadError">
            <span>{{ 'delivery-note.loading_document' | translate }}</span>
        </div>

        <div class="pdf-error" *ngIf="loadError">
            <p>{{ 'delivery-note.error_viewing_document' | translate }}</p>
        </div>

        <ng-container *ngIf="pdfSrc && !loadError">
            <div class="pdf-layout">

                <div class="pdf-sidebar">
                    <button *ngFor="let p of pages; let i = index" type="button" class="pdf-thumb-btn"
                        [class.active]="p === currentPage" (click)="goToPage(p)">
                        <div class="pdf-thumb">
                            <img *ngIf="thumbnails[i]" [src]="thumbnails[i]" alt="Page {{ p }}" class="pdf-thumb-img" />
                            <div *ngIf="!thumbnails[i]" class="pdf-thumb-placeholder"></div>
                        </div>
                        <span class="pdf-thumb-num">{{ p }}</span>
                    </button>
                </div>

                <div class="pdf-main">
                    <pdf-viewer
                        [src]="pdfSrc"
                        [page]="currentPage"
                        [render-text]="true"
                        [original-size]="false"
                        [fit-to-page]="true"
                        [zoom-scale]="'page-width'"
                        [autoresize]="true"
                        [show-all]="false"
                        (after-load-complete)="onPdfLoaded($event)"
                        (error)="onPdfError($event)"
                        class="pdf-canvas"
                    ></pdf-viewer>
                </div>

            </div>
        </ng-container>

        <div class="pdf-empty" *ngIf="!pdfSrc && !isLoading && !loadError">
            <p>{{ 'delivery-note.no_document_selected' | translate }}</p>
        </div>

    </div>
    </ng-container>

    <div class="pdf-terms-footer" *ngIf="showTerms">
        {{ 'SERVICE_REPORT_DOWNLOAD.20' | translate }}
        <a href="https://cafler.com/terminos-y-condiciones/" target="_blank" rel="noopener noreferrer">
            {{ 'SERVICE_REPORT_DOWNLOAD.21' | translate }}
        </a>.
    </div>

</div>